import {
	ChangeDetectionStrategy,
	Component,
	DestroyRef,
	inject,
	Input,
	OnInit,
	signal,
} from '@angular/core';

import { MaintenanceSelectorService } from '@app/pages/cmms/components/au-maintenance-selector/maintenance-selector.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AuBodyTextModule } from '@shared/ui-components';
import { NgxTolgeeModule } from '@tolgee/ngx';

@Component({
	selector: 'au-ns-column[value]',
	imports: [AuBodyTextModule, NgxTolgeeModule],
	templateUrl: './au-ns-column.component.html',
	styleUrls: ['./au-ns-column.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuNsColumnComponent implements OnInit {
	readonly maintenanceSelectorService = inject(MaintenanceSelectorService);
	readonly nameDescriptionList = signal({});
	private readonly destroyRef = inject(DestroyRef);

	@Input() value: string;

	ngOnInit(): void {
		this.maintenanceSelectorService.nameDescriptionList
			.pipe(takeUntilDestroyed(this.destroyRef))
			.subscribe(value => this.nameDescriptionList.set(value));
	}
}
